import React from 'react'
import { array, bool, func, string, object, oneOfType } from 'prop-types';
import './styles.scss';

function Button({
  children,
  color = 'primary',
  disabled = false,
  onClick,
  fill = 'full',
  size = 'large',
  type = 'submit',
  classes = '',
  customStyles = {},
  id,
  ...props
}) {
  const finalColorClass = fill === 'outline'
    ? `btn-outline-${color === 'error' ? 'danger' : color}`
    : `btn-${color === 'error' ? 'danger' : color}`;

  const sizeClasses = {
    large: 'btn-lg w-100',
    'medium-lg': 'btn-lg w-100 btn-custom-medium',
    medium: 'w-100',
    small: 'btn-sm',
    smaller: 'btn-sm',
    'smaller-outline': 'btn-sm btn-smaller-outline',
    icon: 'btn-sm p-1'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.large;

  const buttonClasses = [
    'btn',
    finalColorClass,
    sizeClass,
    'rounded',
    disabled ? 'disabled' : '',
    classes
  ].filter(Boolean).join(' ');

  return (
    <button
      {...props}
      disabled={disabled}
      className={buttonClasses}
      onClick={onClick}
      type={type}
      style={customStyles}
      id={id}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  children: oneOfType([string, array]).isRequired,
  color: string,
  classes: string,
  customStyles: object,
  disabled: bool,
  fill: string,
  onClick: func,
  size: string,
  type: string
};

export default Button;